import { Grid, TextField, Button } from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactImageGallery from "react-image-gallery";
import Rating from "react-rating";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import _ from "underscore";
import Modal from "../../components/Modal/Modal";
import ReviewModal from "../../components/Modal/ReviewModal";
import { IsNullOrEmpty, paginate } from "../../helpers/utility";
import {
    addReviewRequest,
    getOrderByIDRequest,
    getOrderRequest,
    updateOrderRequest,
} from "../../store/shopping/shopping.actions";
import {
    getOrderDetail,
    getOrderList,
} from "../../store/shopping/shopping.selector";
import {
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../store/user/user.selector";

const ManageOrder = () => {
    const dispatch = useDispatch();
    const pageSize = 10;
    const [review, setReview] = useState(false);
    const [filter, setFilter] = useState(false);
    const [page, setPage] = useState(1);
    const [description, setDescription] = useState("");
    const [rating, setRating] = useState(2);
    const [orderDetailsModal, setOrderDetailsModal] = useState(false);
    const [shipDetailsModal, setShipDetailsModal] = useState(false);
    const [searchTag, setSearchTag] = useState([]);
    const [courier, setCourier] = useState("");
    const [trackingNumber, setTrackingNumber] = useState("");
    const [estimatedDate, setEstimatedDate] = useState(null);
    const [fullName, setFullName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [orderType, setOrderType] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [statusType, setStatusType] = useState("");

    const handleKeyDown = (e) => {
        if (e.key !== "Enter") return;

        const value = e.target.value;
        if (!value.trim()) return;
        setSearchTag([...searchTag, value]);
        e.target.value = "";
    };

    const removeTag = (index) => {
        setSearchTag(searchTag.filter((tag, i) => i !== index));
    };

    const { allOrders, orderDetail, searchUsers, userProfile } = useSelector(
        (state) => {
            return {
                allOrders: getOrderList(state),
                orderDetail: getOrderDetail(state),
                searchUsers: getSearchedUsers(state),
                userProfile: getUserProfile(state),
            };
        }
    );

    useEffect(() => {
        if (
            orderDetail.firstProduct &&
            orderDetail.firstProduct &&
            orderDetail.firstProduct.courierName
        ) {
            setCourier(orderDetail.firstProduct.courierName);
        }
    }, [orderDetail]);

    useEffect(() => {
        if (
            orderDetail.orderStatus === "ToReceived" &&
            userProfile._id === orderDetail.buyer._id
        ) {
            Swal.fire({
                title: "Order Confirmation",
                text: "Please confirm your order is received.?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "green",
                cancelButtonText: "Cancel",
                confirmButtonText: "Yes",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(
                        updateOrderRequest({
                            id: orderDetail._id,
                            orderStatus: "Completed",
                        })
                    );
                }
            });
        }
    }, [orderDetail]);

    useEffect(() => {
        setFullName(userProfile.fullName);
        setPhoneNumber(userProfile.phone);
    }, [userProfile]);

    const handleSave = (event, order) => {
        event.preventDefault();
        event.stopPropagation();

        event.target.className += " was-validated";

        if (
            !IsNullOrEmpty(trackingNumber) &&
            !IsNullOrEmpty(courier) &&
            !IsNullOrEmpty(fullName) &&
            !IsNullOrEmpty(phoneNumber) &&
            !IsNullOrEmpty(estimatedDate)
        ) {
            if (
                order.orderStatus === "ToShip" &&
                userProfile._id === order.seller._id
            ) {
                dispatch(
                    updateOrderRequest({
                        id: order._id,
                        shippingInfo: {
                            trackingNumber: trackingNumber,
                            courier: courier,
                        },
                        senderInfo: {
                            fullName: fullName,
                            phone: phoneNumber,
                        },
                        estimateTimeArrival: estimatedDate,
                    })
                );
            }
        }
    };

    useEffect(() => {
        dispatch(getOrderRequest());
    }, []);

    let filteredList = allOrders;

    if (searchTag.length > 0) {
        searchTag.forEach((searchText) => {
            filteredList = filteredList.filter((item) => {
                return (
                    item.buyerUserName
                        .toLowerCase()
                        .indexOf(searchText.toLowerCase()) > -1 ||
                    item.sellerUserName
                        .toLowerCase()
                        .indexOf(searchText.toLowerCase()) > -1 ||
                    item.orderItems.filter(
                        (x) =>
                            x.product.name
                                .toLowerCase()
                                .indexOf(searchText.toLowerCase()) > -1
                    ).length > 0 ||
                    item.orderItems.filter(
                        (x) =>
                            x.product.descriptions
                                .toLowerCase()
                                .indexOf(searchText.toLowerCase()) > -1
                    ).length > 0
                );
            });
        });
    }

    if (!IsNullOrEmpty(orderType)) {
        if (orderType === "Buy") {
            filteredList = filteredList.filter((x) => x.isBuyer);
        } else if (orderType === "Sell") {
            filteredList = filteredList.filter((x) => !x.isBuyer);
        }
    }

    if (!IsNullOrEmpty(sortBy)) {
        if (sortBy === "Weekly") {
            let ed = moment().unix();
            let sd = moment().startOf("week").unix();

            filteredList = filteredList.filter((x) => {
                let time = moment(x.dateCreated).unix();
                return time > sd && time < ed;
            });
        } else if (sortBy === "Monthly") {
            let ed = moment().unix();
            let sd = moment().startOf("month").unix();
            filteredList = filteredList.filter((x) => {
                let time = moment(x.dateCreated).unix();
                return time > sd && time < ed;
            });
        } else if (sortBy === "Yearly") {
            let ed = moment().unix();
            let sd = moment().startOf("year").unix();
            filteredList = filteredList.filter((x) => {
                let time = moment(x.dateCreated).unix();
                return time > sd && time < ed;
            });
        }
    }

    if (!IsNullOrEmpty(statusType)) {
        filteredList = filteredList.filter(
            (x) => x.orderStatus === statusType || statusType === "All Status"
        );
    }

    let totalPages = Math.ceil(filteredList.length / pageSize);
    let pages = [];
    for (let i = 1; i <= totalPages; i++) {
        pages.push(
            <li>
                <a
                    className={`px-3 py-2 leading-tight  bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${i === page ? "text-blue" : "text-gray-500"
                        }`}
                    onClick={() => setPage(i)}
                    href="#"
                >
                    {i}
                </a>
            </li>
        );
    }

    const transactionList = paginate(filteredList, pageSize, page);

    const manageOrder = transactionList.map((order, index) => {
        let buyer = _.find(searchUsers, (x) => order.buyer._id === x._id);
        if (!buyer) {
            buyer = _.find(searchUsers, (x) => order.buyer === x._id);
        }
        return {
            id: order._id,
            userImg: !order.isBuyer
                ? buyer && getImage(buyer.attachments)
                : getImage(order.seller.attachments),
            userName: !order.isBuyer
                ? order.buyerUserName
                : order.sellerUserName,
            userId: order.code,
            itemImg:
                order.firstProduct.product && order.firstProduct.product.images
                    ? order.firstProduct.product &&
                    order.firstProduct.product.images
                    : getImage({}),
            itemName: order.firstProduct && order.firstProduct.productName,
            itemId:
                order.firstProduct.product && order.firstProduct.product.code,
            totalOrder: order.firstProduct && order.firstProduct.quantity,
            totalPrice: order.totalPrices.toFixed(2),
            trackingNo: order.shippingInfo && order.shippingInfo.trackingNumber,
            status:
                order.orderStatus === "ToShip"
                    ? "To ship"
                    : order.orderStatus === "ToReceive"
                        ? "To receive"
                        : order.orderStatus === "ToReceived"
                            ? "To receive"
                            : order.orderStatus,
        };
    });

    if (manageOrder.length === 0) {
        return (
            <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
                <div className="">
                    <div className="mb-3">
                        <h2 className="text-xl font-bold text-ebony-color capitalize">
                            Manage order
                        </h2>
                        <p className="text-md font-medium text-black-60">
                            View your order status including items that you
                            bought or sold.
                        </p>
                    </div>
                    <div className="p-4 pb-0 h-[70vh] flex text-center items-center justify-center bg-white rounded-lg border border-b-0 border-black-10">
                        <p className="text-center text-lg text-black-50 flex text-center items-center flex-col">
                            <svg
                                width="100"
                                height="100"
                                viewBox="0 0 16 16"
                                className="stroke-current"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7.99967 3.00001V1.33334M7.99967 3.00001C7.0792 3.00001 6.33301 3.7462 6.33301 4.66668C6.33301 5.58715 7.0792 6.33334 7.99967 6.33334M7.99967 3.00001C8.92015 3.00001 9.66634 3.7462 9.66634 4.66668C9.66634 5.58715 8.92015 6.33334 7.99967 6.33334M2.99967 13C3.92015 13 4.66634 12.2538 4.66634 11.3333C4.66634 10.4129 3.92015 9.66668 2.99967 9.66668M2.99967 13C2.0792 13 1.33301 12.2538 1.33301 11.3333C1.33301 10.4129 2.0792 9.66668 2.99967 9.66668M2.99967 13V14.6667M2.99967 9.66668V1.33334M7.99967 6.33334V14.6667M12.9997 13C13.9201 13 14.6663 12.2538 14.6663 11.3333C14.6663 10.4129 13.9201 9.66668 12.9997 9.66668M12.9997 13C12.0792 13 11.333 12.2538 11.333 11.3333C11.333 10.4129 12.0792 9.66668 12.9997 9.66668M12.9997 13V14.6667M12.9997 9.66668V1.33334"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <br />
                            There are no items to manage.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
            <div className="mb-[18px]">
                <h2 className="text-xl font-bold text-ebony-color capitalize">
                    Manage order
                </h2>
                <p className="text-sm font-medium text-black-50">
                    View your order status including items that you bought or
                    sold.
                </p>
            </div>

            <div className="p-4 bg-white rounded-lg border border-black-10 flex-grow overflow-y-auto">
                <div className="mb-3.5">
                    <div className="flex items-center mb-2.5">
                        <div className="relative mr-3.5 w-full">
                            <input
                                type="search"
                                onKeyDown={handleKeyDown}
                                className="py-2.5 pl-12 w-full text-black-color placeholder:text-black-60 border border-black-10 rounded-[40px] text-sm sm:text-md outline-none"
                                placeholder="Search.."
                            />

                            <span className="text-xl absolute top-2/4 -translate-y-2/4 left-[18px] text-black-60">
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z"
                                        fill="black"
                                        fillOpacity="0.5"
                                    />
                                </svg>
                            </span>
                        </div>

                        <div
                            onClick={() => setFilter(true)}
                            className="flex items-center py-2.5 px-5 text-md font-medium text-black-50 border border-black-10 rounded-lg cursor-pointer capitalize"
                        >
                            <span className="inline-block mr-2">
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1.25 2.25C1.25 1.69772 1.69772 1.25 2.25 1.25H13.75C14.3023 1.25 14.75 1.69772 14.75 2.25V3.83579C14.75 4.101 14.6446 4.35536 14.4571 4.54289L9.79289 9.20711C9.60536 9.39464 9.5 9.649 9.5 9.91421V11.75L6.5 14.75V9.91421C6.5 9.649 6.39464 9.39464 6.20711 9.20711L1.54289 4.54289C1.35536 4.35536 1.25 4.101 1.25 3.83579V2.25Z"
                                        stroke="black"
                                        strokeOpacity="0.5"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                            <span>Filters</span>
                        </div>
                    </div>

                    {/* Search Tag  */}
                    <div className="flex items-center justify-start flex-wrap gap-1">
                        {searchTag.map((tag, index) => (
                            <div
                                key={index}
                                className="py-[7px] px-3 border border-black-10 text-black-50 hover:text-ebony-color rounded-lg flex items-center capitalize cursor-pointer"
                            >
                                <span className="inline-block mr-3">{tag}</span>
                                <span
                                    onClick={() => removeTag(index)}
                                    className=""
                                >
                                    <svg
                                        width="12"
                                        height="12"
                                        className="stroke-current"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.5 10.5L10.5 1.5M1.5 1.5L10.5 10.5"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                            </div>
                        ))}
                        {orderType && (
                            <div className="py-[7px] px-3 border border-black-10 text-black-50 hover:text-ebony-color rounded-lg flex items-center capitalize cursor-pointer">
                                <span className="inline-block mr-3">
                                    {orderType}
                                </span>
                                <span
                                    onClick={() => setOrderType("")}
                                    className=""
                                >
                                    <svg
                                        width="12"
                                        height="12"
                                        className="stroke-current"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.5 10.5L10.5 1.5M1.5 1.5L10.5 10.5"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                            </div>
                        )}
                        {sortBy && (
                            <div className="py-[7px] px-3 border border-black-10 text-black-50 hover:text-ebony-color rounded-lg flex items-center capitalize cursor-pointer">
                                <span className="inline-block mr-3">
                                    {sortBy}
                                </span>
                                <span
                                    onClick={() => setSortBy("")}
                                    className=""
                                >
                                    <svg
                                        width="12"
                                        height="12"
                                        className="stroke-current"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.5 10.5L10.5 1.5M1.5 1.5L10.5 10.5"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                            </div>
                        )}
                        {statusType && (
                            <div className="py-[7px] px-3 border border-black-10 text-black-50 hover:text-ebony-color rounded-lg flex items-center capitalize cursor-pointer">
                                <span className="inline-block mr-3">
                                    {statusType}
                                </span>
                                <span
                                    onClick={() => setStatusType("")}
                                    className=""
                                >
                                    <svg
                                        width="12"
                                        height="12"
                                        className="stroke-current"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.5 10.5L10.5 1.5M1.5 1.5L10.5 10.5"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                <div className="w-full text-left">
                    <div className="text-md font-medium capitalize text-black-50 border-b border-black-10 hidden md:block">
                        <tr className="grid grid-cols-8">
                            <th
                                scope="col"
                                className="pt-[18px] pb-3.5 ppl-4 ppr-10 whitespace-nowrap col-span-2"
                            >
                                name
                            </th>
                            <th
                                scope="col"
                                className="pt-[18px] pb-3.5 ppx-10 whitespace-nowrap col-span-2"
                            >
                                item
                            </th>
                            <th
                                scope="col"
                                className="pt-[18px] pb-3.5 ppx-6 whitespace-nowrap"
                            >
                                order total
                            </th>
                            <th
                                scope="col"
                                className="pt-[18px] pb-3.5 ppx-6 whitespace-nowrap "
                            >
                                total
                            </th>
                            <th
                                scope="col"
                                className="pt-[18px] pb-3.5 ppx-6 whitespace-nowrap"
                            >
                                tracking no
                            </th>
                            <th
                                scope="col"
                                className="pt-[18px] pb-3.5 ppx-6 whitespace-nowrap md:pl-8 lg:pl-7"
                            >
                                status
                            </th>
                        </tr>
                    </div>
                    <div className="">
                        {manageOrder.map((order) => (
                            <div
                                key={order.id}
                                onClick={() => {
                                    dispatch(getOrderByIDRequest(order.id));
                                    order.status.toLowerCase() === "to ship"
                                        ? setShipDetailsModal(true)
                                        : setOrderDetailsModal(true);
                                }}
                                className="flex md:flex-none w-full py-2 md:py-0 border-b border-black-10 md:border-none"
                            >
                                <div className="flex-1 text-md font-medium capitalize text-black-50 md:hidden ">
                                    <tr className=" grid gap-y- grid-cols-1">
                                        <div className="py-1  whitespace-nowrap min-h-[53px] flex items-center">
                                            name
                                        </div>
                                        <div className="py-1  whitespace-nowrap min-h-[53px] flex items-center">
                                            item
                                        </div>
                                        <div className="py-1 mt-2.5 whitespace-nowrap">
                                            order total
                                        </div>
                                        <div className="py-1 whitespace-nowrap ">
                                            total
                                        </div>
                                        <div className="py-1 whitespace-nowrap">
                                            tracking no
                                        </div>
                                        <div className="py-1 whitespace-nowrap">
                                            status
                                        </div>
                                    </tr>
                                </div>
                                <tr className="flex-1 text-sm text-black-60 md:border-b border-black-10 w-full grid gap-y- grid-cols-1 md:grid-cols-8 items-center">
                                    <td className="py-1 md:py-3 ppl-3.5 ppr-10 md:col-span-2">
                                        <div className="flex items-center">
                                            <img
                                                src={order.userImg}
                                                alt=""
                                                className="w-[45px] h-[45px] rounded-full mr-3"
                                            />
                                            <div className="">
                                                <h4 className="text-md font-medium text-black mb-0.5 capitalize whitespace-nowrap">
                                                    {order.userName}
                                                </h4>
                                                <p className="">
                                                    {order.userId}
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="py-1 md:py-3 ppx-10  md:col-span-2">
                                        <div className=" flex items-center">
                                            <img
                                                src={order.itemImg}
                                                alt=""
                                                className="w-[45px] h-[45px] rounded-full mr-3"
                                            />
                                            <div className="">
                                                <h4 className="text-md font-medium text-black mb-0.5 capitalize whitespace-nowrap overflow-text max-w-[200px]">
                                                    {order.itemName}
                                                </h4>
                                                <p className=" uppercase">
                                                    {order.itemId}
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="py-1 md:py-3 ppx-6 md:pl-7 ">
                                        x{order.totalOrder}
                                    </td>
                                    <td className="py-1 md:py-3 ppx-6 uppercase whitespace-nowrap">
                                        myr {order.totalPrice}
                                    </td>
                                    <td className="py-1 md:py-3 ppx-6">
                                        {order.trackingNo}
                                    </td>
                                    <td className="py-1 md:py-3 ppx-6 md:pl-8 lg:pl-7">
                                        <Link
                                            to=""
                                            className={`${order.status.toLowerCase() ===
                                                "to ship"
                                                ? "text-orange-color"
                                                : "text-[#168A2F]"
                                                } capitalize hover:underline`}
                                        >
                                            {order.status}
                                        </Link>
                                    </td>
                                </tr>
                            </div>
                        ))}
                    </div>
                </div>

                {/* review Modal  */}
                <ReviewModal show={review} onClose={() => setReview(false)}>
                    <div className="">
                        <div className="flex items-center justify-between mb-2.5">
                            <h2 className="text-xl font-bold text-ebony-color capitalize">
                                Filter
                            </h2>
                            <span
                                onClick={() => setReview(false)}
                                className="cursor-pointer"
                            >
                                <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1 11L11 1M1 1L11 11"
                                        stroke="black"
                                        strokeOpacity="0.5"
                                        strokeWidth="1.26316"
                                        strokeLinecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </span>
                        </div>

                        <div className="mb-4">
                            <h6 className="text-sm font-medium text-black-50 mb-2.5">
                                Order type
                            </h6>
                            <div className="rounded-md border border-black-10 p-2.5 mb-2.5">
                                <span className="text-sm font-medium text-black-50 capitalize inline-block mb-0.5">
                                    ratings
                                </span>
                                <div className=" flex items-center space-x-1">
                                    <Rating
                                        onChange={(e) => setRating(e)}
                                        initialRating={rating}
                                        fractions={2}
                                        
                                        emptySymbol={
                                            <span className="icon-text">
                                                <span>
                                                    <svg
                                                        width="19"
                                                        height="18"
                                                        viewBox="0 0 19 18"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M9.43273 0L11.5558 6.53405H18.4261L12.8679 10.5723L14.9909 17.1064L9.43273 13.0681L3.87454 17.1064L5.99758 10.5723L0.439381 6.53405H7.30969L9.43273 0Z"
                                                            fill="#C1C1C1"
                                                        />
                                                    </svg>
                                                </span>
                                            </span>
                                        }
                                        fullSymbol={[1, 2, 3, 4, 5].map((n) => (
                                            <span className="icon-text">
                                                <span>
                                                    <svg
                                                        width="19"
                                                        height="18"
                                                        viewBox="0 0 19 18"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M9.94445 0L12.0675 6.53405H18.9378L13.3796 10.5723L15.5027 17.1064L9.94445 13.0681L4.38625 17.1064L6.5093 10.5723L0.951099 6.53405H7.82141L9.94445 0Z"
                                                            fill="#FFB800"
                                                        />
                                                    </svg>
                                                </span>
                                            </span>
                                        ))}
                                    />
                                </div>
                            </div>
                            <div className="p-2.5 rounded-md border border-black-10">
                                <textarea
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    cols="30"
                                    rows="5"
                                    className="w-full min-h-24 resize-none text-sm placeholder:text-black-50 outline-none"
                                    placeholder="Tell us more about your experience"
                                ></textarea>
                            </div>
                        </div>

                        <button
                            disabled={IsNullOrEmpty(description)}
                            onClick={() => {
                                dispatch(addReviewRequest({
                                    'rating': rating,
                                    'description': description,
                                    'product': orderDetail.firstProduct.product._id
                                }));
                                setReview(false);
                                setDescription("");
                            }}
                            className="py-2.5 px-14 text-md font-bold text-white bg-orange-color rounded-lg "
                        >
                            save
                        </button>
                    </div>
                </ReviewModal>

                {/* Filter Modal  */}
                <Modal show={filter} onClose={() => setFilter(false)}>
                    <div className="">
                        <div className="flex items-center justify-between mb-2.5">
                            <h2 className="text-xl font-bold text-ebony-color capitalize">
                                Filter
                            </h2>
                            <span
                                onClick={() => setFilter(false)}
                                className="cursor-pointer"
                            >
                                <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1 11L11 1M1 1L11 11"
                                        stroke="black"
                                        strokeOpacity="0.5"
                                        strokeWidth="1.26316"
                                        strokeLinecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </span>
                        </div>

                        <div className=" mb-[26px]">
                            <h6 className="text-sm font-medium text-black-50 mb-2.5">
                                Order type
                            </h6>
                            <div className="flex items-center gap-4">
                                <label
                                    htmlFor="order-filter-radio-1"
                                    className="flex items-center mb-1 cursor-pointer "
                                >
                                    <input
                                        id="order-filter-radio-1"
                                        type="radio"
                                        value=""
                                        checked={orderType === "Buy"}
                                        onChange={(e) =>
                                            e.target.checked
                                                ? setOrderType("Buy")
                                                : ""
                                        }
                                        name="orderType"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                    />
                                    <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                    <p className="ml-2 text-sm text-[#374151] ">
                                        Buy
                                    </p>
                                </label>
                                <label
                                    htmlFor="order-filter-radio-2"
                                    className="flex items-center mb-1 cursor-pointer "
                                >
                                    <input
                                        id="order-filter-radio-2"
                                        type="radio"
                                        value=""
                                        name="orderType"
                                        checked={orderType === "Sell"}
                                        onChange={(e) =>
                                            e.target.checked
                                                ? setOrderType("Sell")
                                                : ""
                                        }
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                    />
                                    <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                    <p className="ml-2 text-sm text-[#374151] ">
                                        Sell
                                    </p>
                                </label>
                            </div>
                        </div>

                        <div className=" mb-[26px]">
                            <h6 className="text-sm font-medium text-black-50 mb-2.5">
                                Sort by
                            </h6>
                            <div className="flex items-center gap-4">
                                <label
                                    htmlFor="sort-filter-radio-1"
                                    className="flex items-center mb-1 cursor-pointer "
                                >
                                    <input
                                        id="sort-filter-radio-1"
                                        type="radio"
                                        value=""
                                        checked={sortBy === "All Time"}
                                        onChange={(e) =>
                                            e.target.checked
                                                ? setSortBy("All Time")
                                                : ""
                                        }
                                        name="sortBy"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                    />
                                    <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                    <p className="ml-2 text-sm text-[#374151] ">
                                        All Time
                                    </p>
                                </label>
                                <label
                                    htmlFor="sort-filter-radio-2"
                                    className="flex items-center mb-1 cursor-pointer "
                                >
                                    <input
                                        id="sort-filter-radio-2"
                                        type="radio"
                                        value=""
                                        name="sortBy"
                                        checked={sortBy === "Monthly"}
                                        onChange={(e) =>
                                            e.target.checked
                                                ? setSortBy("Monthly")
                                                : ""
                                        }
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                    />
                                    <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                    <p className="ml-2 text-sm text-[#374151] ">
                                        Monthly
                                    </p>
                                </label>
                                <label
                                    htmlFor="sort-filter-radio-3"
                                    className="flex items-center mb-1 cursor-pointer "
                                >
                                    <input
                                        id="sort-filter-radio-3"
                                        type="radio"
                                        value=""
                                        checked={sortBy === "Weekly"}
                                        onChange={(e) =>
                                            e.target.checked
                                                ? setSortBy("Weekly")
                                                : ""
                                        }
                                        name="sortBy"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                    />
                                    <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                    <p className="ml-2 text-sm text-[#374151] ">
                                        Weekly
                                    </p>
                                </label>
                                <label
                                    htmlFor="sort-filter-radio-4"
                                    className="flex items-center mb-1 cursor-pointer "
                                >
                                    <input
                                        id="sort-filter-radio-4"
                                        type="radio"
                                        value=""
                                        checked={sortBy === "Yearly"}
                                        onChange={(e) =>
                                            e.target.checked
                                                ? setSortBy("Yearly")
                                                : ""
                                        }
                                        name="sortBy"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                    />
                                    <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                    <p className="ml-2 text-sm text-[#374151] ">
                                        Yearly
                                    </p>
                                </label>
                            </div>
                        </div>

                        <div className=" mb-9">
                            <h6 className="text-sm font-medium text-black-50 mb-2.5">
                                By status
                            </h6>
                            <div className="flex items-center gap-4">
                                <label
                                    htmlFor="status-filter-radio-1"
                                    className="flex items-center mb-1 cursor-pointer "
                                >
                                    <input
                                        id="status-filter-radio-1"
                                        type="radio"
                                        value=""
                                        checked={statusType === "All Status"}
                                        onChange={(e) =>
                                            e.target.checked
                                                ? setStatusType("All Status")
                                                : ""
                                        }
                                        name="statusType"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                    />
                                    <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                    <p className="ml-2 text-sm text-[#374151] ">
                                        All
                                    </p>
                                </label>
                                <label
                                    htmlFor="status-filter-radio-2"
                                    className="flex items-center mb-1 cursor-pointer "
                                >
                                    <input
                                        id="status-filter-radio-2"
                                        type="radio"
                                        value=""
                                        checked={statusType === "ToShip"}
                                        onChange={(e) =>
                                            e.target.checked
                                                ? setStatusType("ToShip")
                                                : ""
                                        }
                                        name="statusType"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                    />
                                    <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                    <p className="ml-2 text-sm text-[#374151] ">
                                        To Ship
                                    </p>
                                </label>
                                <label
                                    htmlFor="status-filter-radio-3"
                                    className="flex items-center mb-1 cursor-pointer "
                                >
                                    <input
                                        id="status-filter-radio-3"
                                        type="radio"
                                        value=""
                                        checked={statusType === "ToReceive"}
                                        onChange={(e) =>
                                            e.target.checked
                                                ? setStatusType("ToReceive")
                                                : ""
                                        }
                                        name="statusType"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                    />
                                    <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                    <p className="ml-2 text-sm text-[#374151] ">
                                        To Receive
                                    </p>
                                </label>
                                <label
                                    htmlFor="status-filter-radio-4"
                                    className="flex items-center mb-1 cursor-pointer "
                                >
                                    <input
                                        id="status-filter-radio-4"
                                        type="radio"
                                        value=""
                                        checked={statusType === "Completed"}
                                        onChange={(e) =>
                                            e.target.checked
                                                ? setStatusType("Completed")
                                                : ""
                                        }
                                        name="statusType"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                    />
                                    <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                    <p className="ml-2 text-sm text-[#374151] ">
                                        Completed
                                    </p>
                                </label>
                            </div>
                        </div>
                        <button
                            onClick={() => {
                                setFilter(false);
                                setOrderType("");
                                setStatusType("");
                                setSortBy("");
                            }}
                            className="py-2.5 px-14 text-md font-bold text-blue-600 bg-gray-200 rounded-lg mr-4"
                        >
                            Reset
                        </button>
                        <button
                            onClick={() => {
                                setFilter(false);
                            }}
                            className="py-2.5 px-14 text-md font-bold text-white bg-orange-color rounded-lg "
                        >
                            Apply
                        </button>
                    </div>
                </Modal>

                {orderDetail &&
                    orderDetail.firstProduct &&
                    orderDetail.firstProduct.product && (
                        <Modal
                            show={orderDetailsModal}
                            onClose={() => setOrderDetailsModal(false)}
                        >
                            <div className="bg-white max-w-[870px] max-h-[80vh] overflow-y-auto py-2">
                                <div className="flex items-center justify-between mb-2.5">
                                    <h2 className="text-xl font-bold text-ebony-color capitalize">
                                        order details
                                    </h2>
                                    <span
                                        onClick={() =>
                                            setOrderDetailsModal(false)
                                        }
                                        className="cursor-pointer pr-2.5"
                                    >
                                        <svg
                                            width="12"
                                            height="12"
                                            viewBox="0 0 12 12"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M1 11L11 1M1 1L11 11"
                                                stroke="black"
                                                strokeOpacity="0.5"
                                                strokeWidth="1.26316"
                                                strokeLinecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </span>
                                </div>
                                <div className="grid grid-cols-12 gap-5 mb-[18px]">
                                    <div className="col-span-12 sm:col-span-6 md:col-span-5">
                                        {/* <img
                                            src={getImage(
                                                orderDetail.firstProduct.product
                                                    .attachments
                                            )}
                                            alt=""
                                            className="rounded-lg w-full"
                                        /> */}
                                        <ReactImageGallery
                                            autoPlay={false}
                                            // showNav={false}
                                            showPlayButton={false}
                                            items={
                                                orderDetail.firstProduct.product
                                                    .allAttachments.length > 0
                                                    ? orderDetail.firstProduct.product.allAttachments
                                                        .concat(
                                                            orderDetail
                                                                .firstProduct
                                                                .product
                                                                .attachments
                                                        )
                                                        .map((x) => {
                                                            return {
                                                                thumbnailWidth: 32,
                                                                thumbnailHeight: 32,
                                                                id: x._id,
                                                                original:
                                                                    getImage(
                                                                        x
                                                                    ),
                                                                thumbnail:
                                                                    getImage(
                                                                        x
                                                                    ),
                                                            };
                                                        })
                                                    : [
                                                        {
                                                            thumbnailWidth: 32,
                                                            thumbnailHeight: 32,
                                                            id: orderDetail
                                                                .firstProduct
                                                                .product
                                                                .attachments
                                                                ._id,
                                                            original:
                                                                getImage(
                                                                    orderDetail
                                                                        .firstProduct
                                                                        .product
                                                                        .attachments
                                                                ),
                                                            thumbnail:
                                                                getImage(
                                                                    orderDetail
                                                                        .firstProduct
                                                                        .product
                                                                        .attachments
                                                                ),
                                                        },
                                                    ]
                                            }
                                        />
                                    </div>
                                    <div className="col-span-12 sm:col-span-6 md:col-span-7 space-y-1">
                                        <div className="mb-2.5">
                                            <h4 className="text-base font-medium text-ebony-color capitalize">
                                                {
                                                    orderDetail.firstProduct
                                                        .product.name
                                                }
                                            </h4>
                                            <p className="text-md text-black-50">
                                                {
                                                    orderDetail.firstProduct
                                                        .product.descriptions
                                                }
                                            </p>
                                        </div>
                                        <div className="mb-1">
                                            <h6 className="text-sm font-medium text-black-50 capitalize">
                                                quantity
                                            </h6>
                                            <p className="text-md text-ebony-color">
                                                x
                                                {
                                                    orderDetail.firstProduct
                                                        .quantity
                                                }
                                            </p>
                                        </div>
                                        <div className="mb-1">
                                            <h6 className="text-sm font-medium text-black-50 capitalize">
                                                order ID
                                            </h6>
                                            <p className="text-md text-ebony-color">
                                                {orderDetail.code}
                                            </p>
                                        </div>
                                        <div className="">
                                            <h6 className="text-sm font-medium text-black-50 capitalize">
                                                price
                                            </h6>
                                            <p className="text-xl text-purple-color uppercase ">
                                                {
                                                    orderDetail.firstProduct
                                                        .product.currency
                                                }{" "}
                                                {
                                                    orderDetail.firstProduct
                                                        .prices
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Shipping Details  */}
                                <div className=" mb-[18px]">
                                    <h5 className="text-sm font-medium text-black-50 mb-2.5">
                                        Purchase details
                                    </h5>
                                    <div className="p-2 sm:p-4 border border-black-10 rounded-lg">
                                        <div className="overflow-x-auto relative">
                                            <div className="w-full text-left flex flex-row md:flex-col">
                                                <div className="flex-1 text-sm font-medium capitalize text-black-50">
                                                    <div className="grid grid-cols-1 gap-y-1 md:grid-cols-5">
                                                        <div className="md:py-3 md:px-6 whitespace-nowrap h-[100px] md:h-auto">
                                                            address
                                                        </div>
                                                        <div className="md:py-3 md:px-6 whitespace-nowrap pt-1">
                                                            Purchase Time
                                                        </div>
                                                        <div className="md:py-3 md:px-6 whitespace-nowrap pt-1">
                                                            Shipping fee
                                                        </div>
                                                        <div className="md:py-3 md:px-6 whitespace-nowrap pt-1">
                                                            Discount
                                                        </div>
                                                        <div className="md:py-3 md:px-6 whitespace-nowrap pt-1">
                                                            Total
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex-1">
                                                    <div className="font-bold text-ebony-color text-md grid gap-y-1 grid-cols-1 md:grid-cols-5">
                                                        <div className=" md:px-6 whitespace-nowrap max-w-[262px]  align-top">
                                                            <h4 className="">
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .name
                                                                }
                                                            </h4>
                                                            <p className="whitespace-normal">
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .address
                                                                }
                                                                ,<br />
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .subAddress
                                                                }
                                                                ,<br />
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .city
                                                                }{" "}
                                                                -{" "}
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .postCode
                                                                }{" "}
                                                                ,<br />
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .state
                                                                }
                                                                ,<br />
                                                                {orderDetail
                                                                    .deliveryAddress
                                                                    .country ===
                                                                    "+60"
                                                                    ? "Malaysia"
                                                                    : orderDetail
                                                                        .deliveryAddress
                                                                        .country ===
                                                                        "+1"
                                                                        ? "United States"
                                                                        : "Singapore"}
                                                                ,
                                                                <br />
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .phone
                                                                }
                                                                , <br />
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .email
                                                                }
                                                            </p>
                                                        </div>
                                                        <div className=" md:px-6 align-top">
                                                            {moment(
                                                                orderDetail.dateCreated
                                                            ).format(
                                                                "DD/MM/YYYY hh:mm:ss A"
                                                            )}
                                                        </div>
                                                        <div className=" md:px-6 align-top">
                                                            {
                                                                orderDetail
                                                                    .firstProduct
                                                                    .product
                                                                    .currency
                                                            }{" "}
                                                            {orderDetail.shippingFee.toFixed(
                                                                2
                                                            )}
                                                        </div>
                                                        <div className=" md:px-6 align-top">
                                                            {
                                                                orderDetail
                                                                    .firstProduct
                                                                    .product
                                                                    .currency
                                                            }{" "}
                                                            {orderDetail.discount.toFixed(
                                                                2
                                                            )}
                                                        </div>
                                                        <div className=" md:px-6 align-top">
                                                            {
                                                                orderDetail
                                                                    .firstProduct
                                                                    .product
                                                                    .currency
                                                            }{" "}
                                                            {orderDetail.totalPrices.toFixed(
                                                                2
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Shipment Details  */}
                                <div className=" mb-[18px]">
                                    <h5 className="text-sm font-medium text-black-50 mb-2.5">
                                        Shipping details
                                    </h5>
                                    <div className="p-2 sm:p-4 border border-black-10 rounded-lg">
                                        <div className="overflow-x-auto relative">
                                            <div className="w-full text-left flex flex-row md:flex-col">
                                                <div className="flex-1 text-sm font-medium capitalize text-black-50">
                                                    <tr className="grid grid-cols-1 gap-y-1 md:grid-cols-5">
                                                        <th
                                                            scope="col"
                                                            className="pt-1 md:py-3 md:px-6 whitespace-nowrap"
                                                        >
                                                            courier name
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="pt-1 md:py-3 md:px-6 whitespace-nowrap"
                                                        >
                                                            Tracking number
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="pt-1 md:py-3 md:px-6 whitespace-nowrap"
                                                        >
                                                            Shipper name
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="pt-1 md:py-3 md:px-6 whitespace-nowrap"
                                                        >
                                                            Phone number
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="pt-1 md:py-3 md:px-6 uppercase"
                                                        >
                                                            ETA
                                                        </th>
                                                    </tr>
                                                </div>
                                                <div className="flex-1">
                                                    <tr className="font-bold text-ebony-color text-md grid gap-y-1 grid-cols-1 md:grid-cols-5">
                                                        <th
                                                            scope="row"
                                                            className=" md:px-6"
                                                        >
                                                            <h4 className="">
                                                                {(orderDetail &&
                                                                    orderDetail.shippingInfo &&
                                                                    orderDetail
                                                                        .shippingInfo
                                                                        .courier) ||
                                                                    orderDetail
                                                                        .firstProduct
                                                                        .courierName}
                                                            </h4>
                                                        </th>
                                                        <td className=" md:px-6">
                                                            {orderDetail &&
                                                                orderDetail.shippingInfo &&
                                                                orderDetail
                                                                    .shippingInfo
                                                                    .trackingNumber}
                                                        </td>
                                                        <td className=" md:px-6 overflow-text">
                                                            {orderDetail &&
                                                                orderDetail.senderInfo &&
                                                                orderDetail
                                                                    .senderInfo
                                                                    .fullName}
                                                        </td>
                                                        <td className=" md:px-6">
                                                            {orderDetail &&
                                                                orderDetail.senderInfo &&
                                                                orderDetail
                                                                    .senderInfo
                                                                    .phone}
                                                        </td>
                                                        <td className=" md:px-6">
                                                            {orderDetail.estimateTimeArrival
                                                                ? moment(
                                                                    orderDetail.estimateTimeArrival
                                                                ).format(
                                                                    "DD/MM/YYYY"
                                                                )
                                                                : moment(
                                                                    orderDetail.dateCreated
                                                                ).format(
                                                                    "DD/MM/YYYY"
                                                                )}
                                                        </td>
                                                    </tr>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row gap-y-3 items-center justify-between">
                                    <div className="flex items-center gap-1">
                                        {orderDetail.shippingInfo &&
                                            orderDetail.shippingInfo
                                                .trackingNumber && (
                                                <a
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={`https://parcelsapp.com/en/tracking/${orderDetail.shippingInfo.trackingNumber}`}
                                                    className="py-[7px] px-3.5 text-sm rounded-lg border capitalize border-transparent font-bold text-white bg-orange-color"
                                                >
                                                    Track shipment
                                                </a>
                                            )}
                                        {orderDetail.isBuyer && (
                                            <button
                                                onClick={() => setReview(true)}
                                                className="py-[7px] px-3.5 text-sm rounded-lg border capitalize border-black-10 font-medium text-black-50 bg-white"
                                            >
                                                Add Review
                                            </button>
                                        )}

                                        <button className="py-[7px] px-3.5 text-sm rounded-lg border capitalize border-black-10 font-medium text-black-50 bg-white">
                                            Contact Support
                                        </button>
                                    </div>
                                    {orderDetail.isBuyer && (
                                        <button
                                            onClick={() =>
                                                setOrderDetailsModal(false)
                                            }
                                            className="py-[7px] px-3.5 text-sm rounded-lg border capitalize border-black-10 font-medium text-black-50 bg-white flex items-center"
                                        >
                                            <span className="inline-block mr-2.5">
                                                <svg
                                                    width="14"
                                                    height="14"
                                                    className="stroke-current"
                                                    viewBox="0 0 14 14"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M1 10L1 10.75C1 11.9926 2.00736 13 3.25 13L10.75 13C11.9926 13 13 11.9926 13 10.75L13 10M10 7L7 10M7 10L4 7M7 10L7 1"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                            </span>
                                            <span>
                                                <a href={orderDetail.link} target="_blank">Download receipt
                                                </a>
                                            </span>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </Modal>
                    )}

                {orderDetail &&
                    orderDetail.firstProduct &&
                    orderDetail.firstProduct.product && (
                        <Modal
                            show={shipDetailsModal}
                            onClose={() => setShipDetailsModal(false)}
                        >
                            <div className="bg-white max-w-[870px] max-h-[80vh] overflow-y-auto py-2">
                                <div className="flex items-center justify-between mb-2.5">
                                    <h2 className="text-xl font-bold text-ebony-color capitalize">
                                        order details
                                    </h2>
                                    <span
                                        onClick={() =>
                                            setShipDetailsModal(false)
                                        }
                                        className="cursor-pointer pr-2.5"
                                    >
                                        <svg
                                            width="12"
                                            height="12"
                                            viewBox="0 0 12 12"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M1 11L11 1M1 1L11 11"
                                                stroke="black"
                                                strokeOpacity="0.5"
                                                strokeWidth="1.26316"
                                                strokeLinecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </span>
                                </div>
                                <div className="grid grid-cols-12 gap-5 mb-[18px]">
                                    <div className="col-span-12 sm:col-span-6 md:col-span-5">
                                        <ReactImageGallery
                                            autoPlay={false}
                                            // showNav={false}
                                            showPlayButton={false}
                                            items={
                                                orderDetail.firstProduct.product
                                                    .allAttachments.length > 0
                                                    ? orderDetail.firstProduct.product.allAttachments
                                                        .concat(
                                                            orderDetail
                                                                .firstProduct
                                                                .product
                                                                .attachments
                                                        )
                                                        .map((x) => {
                                                            return {
                                                                thumbnailWidth: 32,
                                                                thumbnailHeight: 32,
                                                                id: x._id,
                                                                original:
                                                                    getImage(
                                                                        x
                                                                    ),
                                                                thumbnail:
                                                                    getImage(
                                                                        x
                                                                    ),
                                                            };
                                                        })
                                                    : [
                                                        {
                                                            thumbnailWidth: 32,
                                                            thumbnailHeight: 32,
                                                            id: orderDetail
                                                                .firstProduct
                                                                .product
                                                                .attachments
                                                                ._id,
                                                            original:
                                                                getImage(
                                                                    orderDetail
                                                                        .firstProduct
                                                                        .product
                                                                        .attachments
                                                                ),
                                                            thumbnail:
                                                                getImage(
                                                                    orderDetail
                                                                        .firstProduct
                                                                        .product
                                                                        .attachments
                                                                ),
                                                        },
                                                    ]
                                            }
                                        />
                                    </div>
                                    <div className="col-span-12 sm:col-span-6 md:col-span-7 space-y-1">
                                        <div className="mb-2.5">
                                            <h4 className="text-base font-medium text-ebony-color capitalize">
                                                {
                                                    orderDetail.firstProduct
                                                        .product.name
                                                }
                                            </h4>
                                            <p className="text-md text-black-50">
                                                {
                                                    orderDetail.firstProduct
                                                        .product.descriptions
                                                }
                                            </p>
                                        </div>
                                        <div className="mb-1">
                                            <h6 className="text-sm font-medium text-black-50 capitalize">
                                                quantity
                                            </h6>
                                            <p className="text-md text-ebony-color">
                                                x
                                                {
                                                    orderDetail.firstProduct
                                                        .quantity
                                                }
                                            </p>
                                        </div>
                                        <div className="mb-1">
                                            <h6 className="text-sm font-medium text-black-50 capitalize">
                                                order ID
                                            </h6>
                                            <p className="text-md text-ebony-color">
                                                {orderDetail.code}
                                            </p>
                                        </div>
                                        <div className="">
                                            <h6 className="text-sm font-medium text-black-50 capitalize">
                                                price
                                            </h6>
                                            <p className="text-xl text-purple-color uppercase ">
                                                {
                                                    orderDetail.firstProduct
                                                        .product.currency
                                                }{" "}
                                                {
                                                    orderDetail.firstProduct
                                                        .prices
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Shipping Details  */}
                                <div className=" mb-[18px]">
                                    <h5 className="text-sm font-medium text-black-50 mb-2.5">
                                        Purchase details
                                    </h5>
                                    <div className="p-2 sm:p-4 border border-black-10 rounded-lg">
                                        <div className="overflow-x-auto relative">
                                            <div className="w-full text-left flex flex-row md:flex-col">
                                                <div className="flex-1 text-sm font-medium capitalize text-black-50">
                                                    <div className="grid grid-cols-1 gap-y-1 md:grid-cols-5">
                                                        <div className="md:py-3 md:px-6 whitespace-nowrap h-[100px] md:h-auto">
                                                            address
                                                        </div>
                                                        <div className="md:py-3 md:px-6 whitespace-nowrap pt-1">
                                                            Purchase Time
                                                        </div>
                                                        <div className="md:py-3 md:px-6 whitespace-nowrap pt-1">
                                                            Shipping fee
                                                        </div>
                                                        <div className="md:py-3 md:px-6 whitespace-nowrap pt-1">
                                                            Discount
                                                        </div>
                                                        <div className="md:py-3 md:px-6 whitespace-nowrap pt-1">
                                                            Total
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex-1">
                                                    <div className="font-bold text-ebony-color text-md grid gap-y-1 grid-cols-1 md:grid-cols-5">
                                                        <div className=" md:px-6 whitespace-nowrap max-w-[262px]  align-top">
                                                            <p className="whitespace-normal">
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .name
                                                                }
                                                            </p>
                                                            <p className="whitespace-normal">
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .address
                                                                }
                                                                ,<br />
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .subAddress
                                                                }
                                                                ,<br />
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .city
                                                                }{" "}
                                                                -{" "}
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .postCode
                                                                }{" "}
                                                                ,<br />
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .state
                                                                }
                                                                ,<br />
                                                                {orderDetail
                                                                    .deliveryAddress
                                                                    .country ===
                                                                    "+60"
                                                                    ? "Malaysia"
                                                                    : orderDetail
                                                                        .deliveryAddress
                                                                        .country ===
                                                                        "+1"
                                                                        ? "United States"
                                                                        : "Singapore"}
                                                                ,
                                                                <br />
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .phone
                                                                }
                                                                , <br />
                                                                {
                                                                    orderDetail
                                                                        .deliveryAddress
                                                                        .email
                                                                }
                                                            </p>
                                                        </div>
                                                        <div className=" md:px-6 align-top">
                                                            {moment(
                                                                orderDetail.dateCreated
                                                            ).format(
                                                                "DD/MM/YYYY hh:mm:ss A"
                                                            )}
                                                        </div>
                                                        <div className=" md:px-6 align-top">
                                                            {
                                                                orderDetail
                                                                    .firstProduct
                                                                    .product
                                                                    .currency
                                                            }{" "}
                                                            {orderDetail.shippingFee.toFixed(
                                                                2
                                                            )}
                                                        </div>
                                                        <div className=" md:px-6 align-top">
                                                            {
                                                                orderDetail
                                                                    .firstProduct
                                                                    .product
                                                                    .currency
                                                            }{" "}
                                                            {orderDetail.discount.toFixed(
                                                                2
                                                            )}
                                                        </div>
                                                        <div className=" md:px-6 align-top">
                                                            {
                                                                orderDetail
                                                                    .firstProduct
                                                                    .product
                                                                    .currency
                                                            }{" "}
                                                            {orderDetail.totalPrices.toFixed(
                                                                2
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {userProfile._id === orderDetail.seller._id &&
                                    orderDetail.orderStatus === "ToShip" ? (
                                    <div className=" mb-[18px]">
                                        <h5 className="text-sm font-medium text-black-50 mb-2.5">
                                            Shipment details
                                        </h5>
                                        <div className="p-2 sm:p-4 border border-black-10 rounded-lg">
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    md={4}
                                                    lg={4}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <TextField
                                                        variant="outlined"
                                                        fullWidth
                                                        placeholder="Courier Name"
                                                        label="Courier Name"
                                                        margin="dense"
                                                        disabled
                                                        value={
                                                            orderDetail
                                                                .firstProduct
                                                                .courierName
                                                        }
                                                        onChange={(e) =>
                                                            setCourier(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    md={4}
                                                    lg={4}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <TextField
                                                        variant="outlined"
                                                        fullWidth
                                                        placeholder="Tracking Number"
                                                        label="Tracking Number"
                                                        margin="dense"
                                                        value={trackingNumber}
                                                        onChange={(e) =>
                                                            setTrackingNumber(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    md={4}
                                                    lg={4}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <TextField
                                                        type="date"
                                                        variant="outlined"
                                                        fullWidth
                                                        placeholder="Estimated Time"
                                                        label="ETA (Estimated Time of Arrival)"
                                                        margin="dense"
                                                        value={estimatedDate}
                                                        onChange={(e) =>
                                                            setEstimatedDate(
                                                                e.target.value
                                                            )
                                                        }
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    md={4}
                                                    lg={4}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        fullWidth
                                                        onClick={(e) => {
                                                            handleSave(
                                                                e,
                                                                orderDetail
                                                            );
                                                            setTimeout(() => {
                                                                dispatch(
                                                                    updateOrderRequest(
                                                                        {
                                                                            id: orderDetail._id,
                                                                            orderStatus:
                                                                                "ToReceived",
                                                                        }
                                                                    )
                                                                );
                                                            }, 1000);
                                                        }}
                                                        disabled={
                                                            IsNullOrEmpty(
                                                                courier
                                                            ) ||
                                                            IsNullOrEmpty(
                                                                trackingNumber
                                                            ) ||
                                                            IsNullOrEmpty(
                                                                estimatedDate
                                                            )
                                                        }
                                                    >
                                                        Save
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                ) : orderDetail.orderStatus === "ToShip" ? (
                                    <div className=" mb-[18px]">
                                        <h5 className="text-sm font-medium text-black-50 mb-2.5">
                                            Shipping details
                                        </h5>
                                        <div className="p-2 sm:p-4 border border-black-10 rounded-lg">
                                            <div className="overflow-x-auto relative">
                                                <div className="w-full text-left flex flex-row md:flex-col">
                                                    <div className="flex-1 text-sm font-medium capitalize text-black-50">
                                                        <tr className="grid grid-cols-1 gap-y-1 md:grid-cols-5">
                                                            <th
                                                                scope="col"
                                                                className="pt-1 md:py-3 md:px-6 whitespace-nowrap"
                                                            >
                                                                courier name
                                                            </th>
                                                            <th
                                                                scope="col"
                                                                className="pt-1 md:py-3 md:px-6 whitespace-nowrap"
                                                            >
                                                                Tracking number
                                                            </th>
                                                            <th
                                                                scope="col"
                                                                className="pt-1 md:py-3 md:px-6 whitespace-nowrap"
                                                            >
                                                                Shipper name
                                                            </th>
                                                            <th
                                                                scope="col"
                                                                className="pt-1 md:py-3 md:px-6 whitespace-nowrap"
                                                            >
                                                                Phone number
                                                            </th>
                                                            <th
                                                                scope="col"
                                                                className="pt-1 md:py-3 md:px-6 uppercase"
                                                            >
                                                                ETA
                                                            </th>
                                                        </tr>
                                                    </div>
                                                    <div className="flex-1">
                                                        <tr className="font-bold text-ebony-color text-md grid gap-y-1 grid-cols-1 md:grid-cols-5">
                                                            <th
                                                                scope="row"
                                                                className=" md:px-6"
                                                            >
                                                                <h4 className="uppercase">
                                                                    {(orderDetail &&
                                                                        orderDetail.shippingInfo &&
                                                                        orderDetail
                                                                            .shippingInfo
                                                                            .courier) ||
                                                                        orderDetail
                                                                            .firstProduct
                                                                            .courierName}
                                                                </h4>
                                                            </th>
                                                            <td className=" md:px-6">
                                                                {orderDetail &&
                                                                    orderDetail.shippingInfo &&
                                                                    orderDetail
                                                                        .shippingInfo
                                                                        .trackingNumber}
                                                            </td>
                                                            <td className=" md:px-6 overflow-text">
                                                                {orderDetail &&
                                                                    orderDetail.senderInfo &&
                                                                    orderDetail
                                                                        .senderInfo
                                                                        .fullName}
                                                            </td>
                                                            <td className=" md:px-6">
                                                                {orderDetail &&
                                                                    orderDetail.senderInfo &&
                                                                    orderDetail
                                                                        .senderInfo
                                                                        .phone}
                                                            </td>
                                                            <td className=" md:px-6">
                                                                {orderDetail.estimateTimeArrival
                                                                    ? moment(
                                                                        orderDetail.estimateTimeArrival
                                                                    ).format(
                                                                        "DD/MM/YYYY"
                                                                    )
                                                                    : moment(
                                                                        orderDetail.dateCreated
                                                                    ).format(
                                                                        "DD/MM/YYYY"
                                                                    )}
                                                            </td>
                                                        </tr>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </Modal>
                    )}
            </div>

            <div className="flex align-center justify-center mt-3">
                <ul className="inline-flex items-center -space-x-px">
                    <li>
                        <a
                            onClick={() => (page > 1 ? setPage(page - 1) : "")}
                            href="#"
                            className="block px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                        >
                            <span className="sr-only">Previous</span>
                            <svg
                                aria-hidden="true"
                                className="w-5 h-5"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </a>
                    </li>
                    {pages}
                    <li>
                        <a
                            href="#"
                            onClick={() =>
                                page > totalPages - 1 ? "" : setPage(page + 1)
                            }
                            className="block px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                        >
                            <span className="sr-only">Next</span>
                            <svg
                                aria-hidden="true"
                                className="w-5 h-5"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default ManageOrder;
